export default __webpack_public_path__ + "static/media/plus-button.99044470.svg";